import { get, post } from './http-calls';

export const getLoanVehicleUsage = async (id, HeaderRecordId) => {
    let res = await get(`LoanVehicleUsage?Id=${id ? id : ''}&HeaderRecordId=${HeaderRecordId}`, { useAuthToken: true });
    return res;
};

export const LoanVehicleSearch = async (id) => {
    let res = await get(`LoanVehicle/LoanVehicle_Search?searchTerm=${id}`, { useAuthToken: true });
    return res;
};

export const postLoanVehicleUsage = async (data) => {
    let res = await post(`LoanVehicleUsage`, data, { useAuthToken: true });
    return res;
};

export const getVehicleServiceHistory_ByRegNo = async (VehicleNumber) => {
    let res = await get(`VehicleSpend/VehicleServiceHistory_ByRegNo?VehicleNumber=${VehicleNumber}`, { useAuthToken: true });
    return res;
};
